import React from "react";

function Footer() {
  return (
    <footer className="foot">
      <div>Made with love</div>
      <div>By Pulkit Gupta</div>
    </footer>
  );
}

export default Footer;
